import { EventRegistry } from '../../../../../domain/event/event.registry';
import { AssetClassEvent } from './asset-class.event';
export class AssetClassDeletedEvent extends AssetClassEvent {
    constructor(payload, metadata, fromPersistence) {
        super({
            subject: `asset-class/${payload.id}`,
            type: AssetClassDeletedEvent.type,
            payload,
            metadata,
            fromPersistence,
        });
    }
}
AssetClassDeletedEvent.type = 'com.treeplotter.api.asset-class.deleted.v1';
EventRegistry.register(AssetClassDeletedEvent.type, AssetClassDeletedEvent);
//# sourceMappingURL=asset-class-deleted.event.js.map